class ApplicationStore {
  private static instance: ApplicationStore | undefined;

  public _data: { [key: string]: any } = {
    errors: {},

    formData: {
      personalData: {},
      healthData: {},
      shotgunData: {},
      refereeData: {},
      offencesData: {},
      attachmentsData: {},
      declarationData: {},
    },
  };

  constructor() {
    if (!ApplicationStore.instance) {
      ApplicationStore.instance = this;
    }

    (window as any).ApplicationStore = this._data;

    // eslint-disable-next-line no-constructor-return
    return ApplicationStore.instance;
  }

  setValue(key: string, value: any) {
    this._data[key] = value;
  }

  getValue(key: string) {
    return this._data?.[key] ? this._data[key] : null;
  }

  clearValue(key: string) {
    this._data[key] = [];
  }

  setStepData(key: string, value: any) {
    this._data.formData[key] = value;
  }

  getStepData(key: string) {
    return this._data.formData?.[key];
  }

  setFormData(value: any) {
    this._data.formData = value;
  }

  setStepErrors(key: number, value: boolean) {
    this._data.errors[key] = value;

    const event = new CustomEvent('setStepErrorsEvent', {
      detail: { data: this._data.errors },
    });
    document.dispatchEvent(event);
  }

  setSubmitFormEvent() {
    const event = new CustomEvent('submitFormEvent', {
      detail: { data: this._data },
    });
    document.dispatchEvent(event);
  }

  resetApplicationState() {
    this._data.formData = {
      personalData: {},
      healthData: {},
      shotgunData: {},
      refereeData: {},
      offencesData: {},
      attachmentsData: {},
      declarationData: {},
    };

    this._data.errors = {};
  }
}

const instance = new ApplicationStore();
Object.freeze(instance);

export default instance;
